<div *ngIf="section == 'intro'">
  <h1><code>TemplateRef</code> and <code>ngTemplateOutlet</code>: blog (with form)</h1>
  <p>
    Like <a href="/#/13">branch 13</a>, but with a form to add blog entries.
  </p>
</div>



<div *ngIf="section == 'default'">
  <h2>default</h2>
</div>



<div *ngIf="section == 'custom1'">
  <h2>custom minimal</h2>
</div>



<div *ngIf="section == 'custom2'">
  <h2>custom</h2>
  <p>
    No image can be selected with this form. A hidden input field will add a placeholder image instead.
  </p>
</div>
